import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import TextField from '@material-ui/core/TextField';
import { ValidationHelper } from '../../common/helpers/ValidationHelper';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ImageComponent } from '../../components/quizzing/ImageComponent';

export class TextComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  change = e => {
    this.setState({
      value: e.target.value
    });
    this.props.handleState(e.target.name, e.target.value)
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          {this.props.mainTitle &&
            <div className={css(CommonStyles.questionMainTitleContainer)}>
              <p className={css(CommonStyles.questionMainTitle)}>{this.props.mainTitle}</p>
              {this.props.showInformationPopup &&
                <div className={css(CommonStyles.questionDetailContainer)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                  <p className={css(CommonStyles.questionDetailContent)}>i</p>
                </div>
              }
            </div>
          }
          {this.props.data.subTitle &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
        </div>
        {this.props.data.image &&
          <div className={css(CommonStyles.outerImageContainer)}>
            <ImageComponent data={this.props.data} />
          </div>
        }
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <TextField
            type={this.props.data.type !== 'TEXT-SHORT' ? 'number' : 'text'}
            onKeyDown={e => ((this.props.data.type === 'INT') && (e.keyCode === 110 || e.keyCode === 190)) && e.preventDefault()}
            name={this.props.data.id}
            value={this.state.value}
            placeholder={this.props.data.type !== 'TEXT-SHORT' ? 'Enter a number' : 'Enter text'}
            onChange={e => this.change(e)}
            disabled={this.props.disabled}
            //helperText={!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.data, this.state.value)}
            margin='normal'
            className={this.props.disabled ? css(CommonStyles.textFieldDisabled) : css(CommonStyles.textField)}
            InputProps={{
              disableUnderline: true,
              classes: {
                root: this.props.disabled ? css(CommonStyles.textFieldContentInputDisabled) : css(CommonStyles.textFieldContentInput)
              }
            }}
          />
          <FormHelperText
            className={css(CommonStyles.errorMsgStyle)}>
            {!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.data, this.state.value)}
          </FormHelperText>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  innerContainer: {
    marginTop: 10,
    marginLeft: 20,
    width: '35%',
    '@media (max-width: 767px)': {
      marginLeft: 10,
      width: '96%'
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      width: '45%',
    },
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/TextComponent.js